import { Link } from "react-router-dom";
import axios from "axios";

export const handleViewDocument = async (
        documentData,
        setLoadingDocument,
        setError,
        setShowViewModal,
        setSelectedDocumentUrl,
        token
) => {
        setLoadingDocument(true);
        setError(null);

        try {
                if (!token) {
                        throw new Error("Authentication token is missing.");
                }
                const file = documentData?.file;
                const fileSource = file?.source || "local";
                const filePath = file?.path;

                if (!filePath || typeof filePath !== 'string') {
                        throw new Error("Invalid document path.");
                }

                if (fileSource === "gDrive") {
                        const previewUrl = filePath.replace(/\/(file\/d\/|open\?id=)([^\/]+)/, "/file/d/$2/preview");
                        // setSelectedDocumentUrl(previewUrl);
                        // setShowViewModal(true);
                        window.open(previewUrl, '_blank');
                } else if (fileSource === "dropbox") {
                        const previewUrl = filePath.replace(/(\?dl=)[0-1]/, "?dl=0");
                        // setSelectedDocumentUrl(previewUrl);
                        // setShowViewModal(true);
                        window.open(previewUrl, '_blank');
                } else {
                        const response = await axios.get(`/api/hr-document/file/${documentData._id}`, {
                                headers: { Authorization: `Bearer ${token}` },
                                responseType: "blob",
                        });

                        const blob = new Blob([response.data], { type: response.headers["content-type"] });
                        const url = window.URL.createObjectURL(blob);
                        setSelectedDocumentUrl(url);
                        setShowViewModal(true);
                }
        } catch (err) {
                console.error("Error fetching document:", err);
                setError(err.message || "Failed to load the document. Please try again.");
        } finally {
                setLoadingDocument(false);
        }
};

export const fetchUsersService = async (selectedCategory, user, setTeamUsers, setVendors, setClients, userCategory, toast) => {
        try {
                if (!user?.token) {
                        throw new Error("Authentication token is missing.");
                }

                const fetchPromises = [];
                const newTeamUsers = [];
                const newVendors = [];
                const newClients = [];

                if (selectedCategory.includes(userCategory.Individual) && selectedCategory.includes(userCategory.Business)) {
                        fetchPromises.push(
                                axios.get('/api/team', {
                                        headers: { Authorization: `Bearer ${user.token}` },
                                }).then(response => {
                                        const data = Array.isArray(response.data) ? response.data : [];
                                        newTeamUsers.push(...data);
                                })
                        );
                }
                if (selectedCategory.includes(userCategory.Vendor)) {
                        fetchPromises.push(
                                axios.get('/api/users/vendors', {
                                        headers: { Authorization: `Bearer ${user.token}` },
                                }).then(response => {
                                        const data = Array.isArray(response.data) ? response.data : [];
                                        newVendors.push(...data);
                                })
                        );
                }
                if (selectedCategory.includes(userCategory.Client)) {
                        fetchPromises.push(
                                axios.get('/api/users/clients', {
                                        headers: { Authorization: `Bearer ${user.token}` },
                                }).then(response => {
                                        const data = Array.isArray(response.data) ? response.data : [];
                                        newClients.push(...data);
                                })
                        );
                }

                await Promise.all(fetchPromises);

                setTeamUsers(newTeamUsers);
                setVendors(newVendors);
                setClients(newClients);
        } catch (error) {
                console.error('Error fetching users:', error);
                const message = error.response?.status === 401 ? 'Unauthorized access.' : 'Failed to load users.';
                toast.error(message, { position: 'bottom-right', autoClose: 2000 });
        }
};

export const handleCheckboxAccountTypeChange = (
        id,
        selectedAccountType,
        setSelectedAccountType,
        filteredDocumentCategories,
        setSelectAllAccountType
) => {
        if (!id || !Array.isArray(selectedAccountType)) {
                console.warn("Invalid input for handleCheckboxAccountTypeChange");
                return;
        }

        const updatedSelection = selectedAccountType.includes(id)
                ? selectedAccountType.filter((item) => item !== id)
                : [...selectedAccountType, id];

        setSelectedAccountType(updatedSelection);
        setSelectAllAccountType(
                filteredDocumentCategories.length > 0 &&
                filteredDocumentCategories.every((cat) => updatedSelection.includes(cat._id))
        );
};

export const fetchCredentials = async (appSettings, user, setGoogleDriveClientId, setGoogleDriveDeveloperKey, setDropBoxClientId, toast) => {
        try {
                if (!appSettings?.appId || !user?.token) {
                        throw new Error("Missing app settings or authentication token.");
                }
                const response = await axios.get(`/api/get/app-settings/${appSettings.appId}`, {
                        headers: { Authorization: `Bearer ${user.token}` },
                });
                const { googleDriveClientId, googleDriveDeveloperKey, dropBoxClientId } = response.data;
                if (!googleDriveClientId || !googleDriveDeveloperKey || !dropBoxClientId) {
                        console.warn("Some credentials are missing in the response.");
                }
                setGoogleDriveClientId(googleDriveClientId || null);
                setGoogleDriveDeveloperKey(googleDriveDeveloperKey || null);
                setDropBoxClientId(dropBoxClientId || null);
        } catch (error) {
                console.error('Error fetching app settings:', error);
                const message = error.response?.status === 401 ? 'Unauthorized access.' : 'Failed to load app settings.';
               // toast.error(message, { position: 'bottom-right', autoClose: 2000 });
        }
};

export const fetchDocumentsService = async (page, limit, user, setDocuments, setTotalRecords, setError) => {
        try {
                if (!user?.token) {
                        throw new Error("Authentication token is missing.");
                }
                const response = await axios.get(`/api/hr-document/all?page=${page + 1}&limit=${limit}`, {
                        headers: { Authorization: `Bearer ${user.token}` },
                });
                const fetchedDocuments = Array.isArray(response.data?.data) ? response.data.data : [];
                setDocuments(fetchedDocuments);
                setTotalRecords(response.data?.totalCount || 0);
        } catch (error) {
                console.error('Error fetching documents:', error);
                const message = error.response?.status === 401 ? 'Unauthorized access.' : 'Failed to load documents.';
                setError(message);
        }
};

export const handleDocumentSubmitService = async (
        documentCategories,
        documentCategory,
        documentTitle,
        selectedCategory,
        selectedTeamUsers,
        selectedVendors,
        selectedClients,
        userCategory,
        toast,
        uploadedFile,
        cloudFileData,
        setIsSubmitLoading,
        user,
        refetchDocuments,
        currentPage,
        perPage,
        handleDocumentClose
) => {
        try {
                if (!user?.token) {
                        throw new Error("Authentication token is missing.");
                }
                if (!documentCategory || !documentCategories.some((cat) => cat._id === documentCategory)) {
                        throw new Error("Please select a valid document category.");
                }
                if (!documentTitle.trim()) {
                        throw new Error("Please enter a document name.");
                }
                if (documentTitle.trim().length > 100) {
                        throw new Error("Document name cannot exceed 100 characters.");
                }
                if (!selectedCategory?.length) {
                        throw new Error("Please select who the document is visible to.");
                }
                if (
                        (selectedCategory.includes(userCategory.Individual) && selectedCategory.includes(userCategory.Business) && !selectedTeamUsers.length) ||
                        (selectedCategory.includes(userCategory.Vendor) && !selectedVendors.length) ||
                        (selectedCategory.includes(userCategory.Client) && !selectedClients.length)
                ) {
                        throw new Error("Please select at least one user for each selected category.");
                }
                if (!uploadedFile && !cloudFileData) {
                        throw new Error("Please upload a document file.");
                }
                if (uploadedFile) {
                        const maxFileSize = 20 * 1024 * 1024;
                        const allowedFileTypes = [
                                'application/pdf',
                                'application/msword',
                                'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
                                'image/jpeg',
                                'image/png',
                        ];
                        if (uploadedFile.size > maxFileSize) {
                                throw new Error('File size exceeds the 20MB limit.');
                        }
                        if (!allowedFileTypes.includes(uploadedFile.type)) {
                                throw new Error('Invalid file type. Allowed types: PDF, DOC, DOCX, JPEG, PNG.');
                        }
                } else if (cloudFileData) {
                        if (!cloudFileData.name || !cloudFileData.url || !cloudFileData.source) {
                                throw new Error('Invalid cloud file data. Missing required fields.');
                        }
                        if (!['gDrive', 'dropbox'].includes(cloudFileData.source)) {
                                throw new Error('Invalid cloud file source.');
                        }
                }

                const formData = new FormData();
                formData.append('category', documentCategory);
                formData.append('title', documentTitle);
                selectedCategory.forEach(category => formData.append('userCategories[]', category));
                [...selectedTeamUsers, ...selectedVendors, ...selectedClients].forEach((userId) => {
                        formData.append('users[]', userId);
                });
                if (uploadedFile) {
                        formData.append('file', uploadedFile);
                } else if (cloudFileData) {
                        formData.append('cloudFile', JSON.stringify(cloudFileData));
                }

                setIsSubmitLoading(true);
                await axios.post('/api/hr-document/add', formData, {
                        headers: { Authorization: `Bearer ${user.token}` },
                });
                // Refetch documents using React Query
                if (refetchDocuments) {
                        await refetchDocuments();
                }
                toast.success("Document added successfully!", { position: "bottom-right", autoClose: 2000 });
                handleDocumentClose();
        } catch (error) {
                // console.error('Error submitting document:', error);
                // toast.error(error.message || "Failed to submit document.", { position: "bottom-right", autoClose: 2000 });
                throw error;
        } finally {
                setIsSubmitLoading(false);
        }
};

export const handleConfirmDelete = async (
        documentToDelete,
        user,
        currentPage,
        perPage,
        setIsSubmitLoading,
        toast,
        refetchDocuments,
        handleCancelDelete
) => {
        if (!documentToDelete?._id) {
                toast.error("Invalid document selected.", { position: "bottom-right", autoClose: 2000 });
                handleCancelDelete();
                return;
        }
        if (!user?.token) {
                toast.error("Authentication token is missing.", { position: "bottom-right", autoClose: 2000 });
                handleCancelDelete();
                return;
        }
        setIsSubmitLoading(true);
        try {
                await axios.delete(`/api/hr-document/${documentToDelete._id}`, {
                        headers: { Authorization: `Bearer ${user.token}` },
                });
                // Refetch documents using React Query
                if (refetchDocuments) {
                        await refetchDocuments();
                }
                toast.success("Document deleted successfully!", { position: "bottom-right", autoClose: 2000 });
        } catch (error) {
                console.error("Error deleting document:", error);
                const message = error.response?.data?.message || "Failed to delete document.";
                toast.error(message, { position: "bottom-right", autoClose: 2000 });
        } finally {
                handleCancelDelete();
                setIsSubmitLoading(false);
        }
};